import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import Auth from "../dashboard/modules/auth/middleware/Auth";
import ProfileComplete from "../dashboard/modules/auth/middleware/ProfileComplete";
import Refund from "./view/Refund.vue";
import RefundCard from "./components/RefundCard.vue";
import RefundList from "./components/RefundList.vue";

export default [
  {
    path: "/refund",
    component: Dashboard,
    name: "Refund",
    children: [
      {
        path: "",
        component: Refund,
        meta: {
          title: "KISEB::StudentRefunds",
          page: "Refund",
        },
        children: [
          {
            path: "listing",
            name: "RefundList",
            component: RefundList,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "refund-request/:code?",
            name: "RefundCard",
            component: RefundCard,
            meta: { middleware: [Auth, ProfileComplete] },
          },
        ],
      },
    ],
  },
];
